import React, { useCallback } from "react";
import { Button, Modal } from "antd";
import { RotateLeftOutlined, DeleteOutlined } from "@ant-design/icons";
import ee from "../../../../services/EventEmitter";
import {
  FORCE_DELETE_DECLARANT_EVENT,
  RESTORE_DECLARANT_EVENT,
} from "../../../../constants/events";
import { MODAL } from "../../../../constants/translates";

interface Props {
  entityId: unknown;
}

const Actions: React.FC<Props> = ({ entityId }) => {
  const onDeleteHandler = useCallback(() => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_delete,
      onOk: () => {
        ee.emit(FORCE_DELETE_DECLARANT_EVENT, entityId);
      },
    });
  }, [entityId]);

  const onRestoreHandler = useCallback(() => {
    Modal.confirm({
      title: MODAL.confirm_title,
      content: MODAL.confirm_restore,
      onOk: () => {
        ee.emit(RESTORE_DECLARANT_EVENT, entityId);
      },
    });
  }, [entityId]);

  return (
    <>
      <Button type="primary" onClick={onDeleteHandler}>
        <DeleteOutlined />
      </Button>

      <Button type="primary" onClick={onRestoreHandler}>
        <RotateLeftOutlined />
      </Button>
    </>
  );
};

export default Actions;
